import { render, staticRenderFns } from "./AutoSms.vue?vue&type=template&id=2239fe6e&"
import script from "./AutoSms.vue?vue&type=script&lang=js&"
export * from "./AutoSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports